<script setup>
import {Head} from "@inertiajs/vue3";
</script>

<template>
    <Head>
        <meta v-if="$page.props.config.app.env == 'staging' || $page.props.config.app.env == 'development'" name="robots" content="noindex">
    </Head>
    <slot/>
</template>
